import { TabItemType } from 'enable-ui';

import { getClassPath } from 'helpers';

import { PATH } from 'constants/path';

import { ASSESSMENT, LEARNER_SCORE, LESSON } from './enum';

export const getClassesDetailTabs = (id: string): TabItemType[] => {
  return [
    {
      label: 'Calendar',
      key: getClassPath(id, PATH.CLASSES_CALENDAR),
      children: <></>,
    },
    {
      label: 'Lessons & Assessments',
      key: getClassPath(id, PATH.CLASSES_LESSONS),
      children: <></>,
    },
    {
      label: 'Members',
      key: getClassPath(id, PATH.CLASSES_MEMBERS),
      children: <></>,
    },
    {
      label: 'Details',
      key: getClassPath(id, PATH.CLASSES_EDIT),
      children: <></>,
    },
  ];
};

export const getLearnerScoresTabs = (): TabItemType[] => {
  return [
    {
      label: 'Lessons',
      key: LEARNER_SCORE.LESSONS,
      children: <></>,
    },
    {
      label: 'Assessments',
      key: LEARNER_SCORE.ASSESSMENTS,
      children: <></>,
    },
  ];
};

export const getLessonTabs = (): TabItemType[] => {
  return [
    {
      label: 'Client’s result',
      key: LESSON.RESULT,
      children: <></>,
    },
    {
      label: 'Exercises',
      key: LESSON.EXERCISES,
      children: <></>,
    },
  ];
};

export const getAssessmentTabs = (): TabItemType[] => {
  return [
    {
      label: 'Client’s result',
      key: ASSESSMENT.RESULT,
      children: <></>,
    },
    {
      label: 'Functional tests',
      key: ASSESSMENT.FUNCTIONAL,
      children: <></>,
    },
  ];
};
